import styled, { css } from 'styled-components'
import theme from 'theme_'
import { CommonLinkButton, CommonButton } from 'components/Button'
import { WhiteBlock } from 'components/Layout'
import { Font14 } from 'components/Typography'

const baseFlex = css`
  display: flex;
  flex-direction: row;
  align-items: center;
`

export const NetworkHomeWidgetContainer = styled(WhiteBlock)`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.base};
  margin-bottom: 14px;
  @media ${theme.devices.mobile} {
    height: 1600px;
  }
`

export const NetworkHomeWidgetHeader = styled.div`
  display: flex;
  justify-content: start;
  gap: ${theme.spacing.base};
`
export const NetworkHomeWidgetLink = styled.div`
  display: flex;
  justify-content: space-between;
  margin-left: 450px;
  gap: ${theme.spacing.base};

  @media ${theme.devices.mobile} {
    margin-left: 50px;
  }
`

export const NetworkHomeWidgetTitle = styled.div`
  font-size: 32px;
  font-weight: 750;
`

export const NetworkHomeWidgetInputMaster = styled.div`
  border: none;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  padding: 0px;

  width: fit-content;
  height: 100%;

  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;
`

export const NetworkHomeWidgetInputBorder = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  padding: 0px 0px 0px 0px;
  gap: 8px;

  width: fit-content;
  height: 100%;

  /* Primary / White */
  background: #ffffff;
  /* Dark Grey - Sec Text */
  border: 0.5px solid #a5a5a5;
  border-radius: 8px;

  flex: none;
  order: 1;
  align-self: stretch;
  flex-grow: 0;

  @media ${theme.devices.mobile} {
    border: 0px solid #a5a5a5;
  }
`

export const NavigateToNetworkAIIcon = styled.img`
  width: 15;
  height: 15;
  color: ${theme.colors.horizonOrange};
  margin: 0px 15px 15px 15px;
`

export const NetworkAINavigateButton = styled(CommonLinkButton)`
  display: flex;
  justify-content: flex-end;
  float: right;
`

export const NetworkAITitleIcon = styled.img`
  width: 48px;
  height: 48px;
  color: ${theme.colors.black};
`

export const NetworkHomeWidgetHealthContainer = styled.div`
  display: flex;
  flex-direction: row;

  @media ${theme.devices.mobile} {
    flex-direction: column;
    gap: ${theme.spacing.xs};
  }
`
export const NetworkHomeWidgetSubsContainer = styled.div`
  display: flex;
  height: 150px;
  flex-direction: row;
  @media ${theme.devices.mobile} {
    flex-direction: column;
    gap: ${theme.spacing.xs};
  }
`

export const SubscriptionStatusInformationContainer = styled.div<{
  isSuccess: boolean
}>`
  padding: 10px 16px;
  background: ${({ isSuccess }) =>
    isSuccess ? 'rgba(35, 197, 20, 0.1)' : 'rgba(197, 41, 42, 0.1)'};
  border-radius: 8px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  justify-content: center;

  > p {
    margin: 0;
  }

  ${CommonButton} {
    width: 100%;
  }

  @media ${theme.devices.tablet} {
    gap: 20px;
    justify-content: initial;
    padding: 12px 16px;

    ${CommonButton} {
      width: initial;
    }
  }
`

export const SubscriptionStatusInformationText = styled.p`
  ${Font14};
  flex: 1;
`

export const SubscriptionStatusButton = styled(CommonButton)`
  display: none;

  @media ${theme.devices.tablet} {
    display: initial;
  }
`

export const NetworkClientsHeader = styled.div`
  ${baseFlex};
  justify-content: space-between;
`
